function n(e,t){return{...e,root:t}}export{n as createRouteConfig};
//# sourceMappingURL=createRouteConfig.js.map
